import React from 'react';
import './contact.css';
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaPaperPlane } from 'react-icons/fa';

const OFFICE_ADDRESS = 'Office Space No. D-6, 1st and 2nd Floor, Sector 2, Noida, Uttar Pradesh, India';
const MAP_EMBED_URL = `https://www.google.com/maps?q=${encodeURIComponent(OFFICE_ADDRESS)}&hl=en&z=16&output=embed`;

const Contact = () => {
  return (
    <div className="contact-page-container">
      <div className="contact-grid">
        <div className="contact-form-section">
          <div className="contact-form-header">
            <span className="contact-form-badge">Get in Touch</span>
            <h1 className="contact-title">Send Us a Message</h1>
            <p className="contact-subtitle">
              Fill in your details and our team will get back to you shortly.
            </p>
          </div>

          <form className="modern-form">
            <div className="form-row-two">
              <div className="form-group">
                <label htmlFor="name" className="form-label-text">Full Name <span className="required">*</span></label>
                <input
                  type="text"
                  className="form-control"
                  id="name"
                  name="name"
                  placeholder="Enter your full name"
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="email" className="form-label-text">Email Address <span className="required">*</span></label>
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  name="email"
                  placeholder="you@example.com"
                  required
                />
              </div>
            </div>

            <div className="form-row-two">
              <div className="form-group">
                <label htmlFor="mobile" className="form-label-text">Mobile Number <span className="required">*</span></label>
                <input
                  type="tel"
                  className="form-control"
                  id="mobile"
                  name="mobile"
                  placeholder="+91 9876543210"
                  pattern="[0-9+\s-]{10,15}"
                  maxLength="15"
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="subject" className="form-label-text">Subject <span className="required">*</span></label>
                <input
                  type="text"
                  className="form-control"
                  id="subject"
                  name="subject"
                  placeholder="How can we help you?"
                  required
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="message" className="form-label-text">Message <span className="required">*</span></label>
              <textarea
                className="form-control"
                id="message"
                name="message"
                rows="5"
                placeholder="Write your message here..."
                required
              ></textarea>
            </div>

            <button type="submit" className="contact-submit-btn">
              <FaPaperPlane />
              Send Message
            </button>
          </form>
        </div>
        <div className="contact-info-section">
          <h2 className="info-main-title">Contact Information</h2>

          <div className="info-list">
            <div className="info-item">
              <FaMapMarkerAlt className="info-icon" />
              <div>
                <p className="info-label">Address</p>
                <p className="info-text">
                  Office Space No. D-6, 1st and 2nd Floor, Sector 2, Noida, Uttar Pradesh, India
                </p>
              </div>
            </div>

            <div className="info-item">
              <FaPhone className="info-icon" />
              <div>
                <p className="info-label">Phone</p>
                <a href="tel:+919560089567" className="info-text info-link">+91 9560089567</a>
              </div>
            </div>

            <div className="info-item">
              <FaEnvelope className="info-icon" />
              <div>
                <p className="info-label">Email</p>
                <a href="mailto:info@fintechsmartsolutions.com" className="info-text info-link">
                  info@fintechsmartsolutions.com
                </a>
              </div>
            </div>
          </div>

          <h2 className="info-main-title location-title">Location</h2>
          <div className="map-container">
            <iframe
              title="Fintech Smart Solutions office location"
              src={MAP_EMBED_URL}
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
